import { combineReducers, configureStore } from "@reduxjs/toolkit";
import "../entities/banks/model/index.js";
import { api } from "../entities/credit/api/api.js";
import "../entities/credit/model/selectors/selectCreditLimits.js";
import "../entities/credit/model/selectors/selectCreditLimitsParams.js";
import "../entities/credit/model/selectors/selectFinancialPrograms.js";
import "../entities/credit/model/selectors/selectFinancialProgramsParams.js";
import "../entities/credit/model/selectors/selectInitialCreditLimits.js";
import "../entities/credit/model/selectors/selectSelectedFinancialProgram.js";
import { slice as slice$1 } from "../features/choice/model/slice.js";
import { middleware } from "../shared/store/config/middleware/index.js";
import { slice as slice$2 } from "../shared/store/config/model/slice.js";
import { slice } from "../entities/banks/model/slice.js";
const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [slice$2.reducerPath]: slice$2.reducer,
  [slice$1.reducerPath]: slice$1.reducer,
  [slice.reducerPath]: slice.reducer
});
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend([api.middleware, middleware]),
  devTools: process.env.NODE_ENV !== "production"
});
export {
  store
};
